// services/fournisseurService.js
import api from './auth';

export const fournisseurService = {
  // Récupérer tous les fournisseurs
  getAllFournisseurs: async (params = {}) => {
    try {
      const response = await api.get('/depot/fournisseurs/', { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des fournisseurs:', error);
      throw error;
    }
  },

  // Récupérer un fournisseur par ID
  getFournisseurById: async (id) => {
    try {
      const response = await api.get(`/depot/fournisseurs/${id}/`);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la récupération du fournisseur ${id}:`, error);
      throw error;
    }
  },

  // Créer un nouveau fournisseur
  createFournisseur: async (fournisseurData) => {
    try {
      const response = await api.post('/depot/fournisseurs/', fournisseurData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création du fournisseur:', error);
      throw error;
    }
  },

  // Mettre à jour un fournisseur
  updateFournisseur: async (id, fournisseurData) => {
    try {
      const response = await api.patch(`/depot/fournisseurs/${id}/`, fournisseurData);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la mise à jour du fournisseur ${id}:`, error);
      throw error;
    }
  },

  // Supprimer un fournisseur
  deleteFournisseur: async (id) => {
    try {
      const response = await api.delete(`/depot/fournisseurs/${id}/`);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la suppression du fournisseur ${id}:`, error);
      throw error;
    }
  },

  // Rechercher des fournisseurs
  searchFournisseurs: async (searchTerm) => {
    try {
      const response = await api.get('/depot/fournisseurs/', {
        params: { search: searchTerm }
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la recherche des fournisseurs:', error);
      throw error;
    }
  },

  // Activer/Désactiver un fournisseur
  toggleActivation: async (id, estActif) => {
    try {
      const response = await api.patch(`/depot/fournisseurs/${id}/`, {
        est_actif: estActif
      });
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la modification de l'état du fournisseur ${id}:`, error);
      throw error;
    }
  },
};

export default fournisseurService;